import React from "react";
import { useFormContext } from "react-hook-form";
import useTranslate from "../../../../core/languages/hooks/useTranslate";
import useCustomerContext from "../../../../customers/hooks/useCustomerContext";
import useGetBasketItems from "../../../../booking/hooks/useGetBasketItems";
import RoomDetail from "../../../../../pages/PageBooking/RoomDetail";
import Loader from "../../../../ui/shared/Loader/Loader";
import Prebooking from "../../../../booking/types/Prebooking";
import HotelDetail from "../../../../hotels/types/HotelDetail";
import {WizardSaveInput} from "../../../types/WizardSaveInput";

interface StepRoomDetailsProps {
  preBooking: Prebooking;
  hotelInfo: HotelDetail;
}

const StepRoomDetails: React.FC<StepRoomDetailsProps> = ({preBooking, hotelInfo}) => {
  const {register, setValue, formState: { errors }} = useFormContext<WizardSaveInput>();
  const t = useTranslate();
  const { languageCode } = useCustomerContext();

  // // // Fetch basket items solo si tenemos un prebookingId
  const preBookingHotelRoomsQuery = useGetBasketItems(preBooking.internalId, {execute: !!preBooking.internalId})
  const {data: preBookingHotelRooms, isLoading: isLoadingRooms} = preBookingHotelRoomsQuery;

  // Use a dummy form object for RoomDetail components
  const form = {register, formState: { errors }};

  if (isLoadingRooms || !preBookingHotelRooms) {
    return <Loader centerHorizontally />;
  }

  return (
    <div className="space-y-6">
      {/* ROOM DETAILS */}
      <div>
        <h3 className="text-2xl font-semibold mb-5">{t("booking.roomDetails")}</h3>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>

        <div className={`${preBookingHotelRooms && preBookingHotelRooms.length > 1 ? 'grid grid-cols-2 gap-6' : ''}`}>
          {preBookingHotelRooms?.map((preBookingHotelRoom, index) => (
            <RoomDetail
              key={preBookingHotelRoom.id}
              form={form}
              basketItem={preBookingHotelRoom}
              index={index}
              prebookingFirstName={preBooking?.name}
              prebookingSurname={preBooking?.surname}
              setValue={setValue}
            />
          ))}
        </div>
      </div>

      {/* CANCELLATION POLICY */}
      {hotelInfo?.trCancellationPolicy?.[languageCode] ? (
        <div>
          <h3 className="text-2xl font-semibold mb-5">
            {t("hotelDetail.cancellationPolicy")}
          </h3>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>
          <div className="text-neutral-6000 dark:text-neutral-300">
            <span
              dangerouslySetInnerHTML={{
                __html: hotelInfo.trCancellationPolicy[languageCode]
              }}
            />
          </div>
        </div>
      ) : (
        <Loader centerHorizontally />
      )}
    </div>
  );
};

export default StepRoomDetails;